<template>
    <ol class="mb-5 list-decimal px-10 text-[1.125rem]/[1.7]">
        <ClientOnly>
            <component
                v-for="item in items.filter((item) => item !== '\n')"
                :key="item.id"
                :is="item"
                class="pl-1"
            />
        </ClientOnly>
    </ol>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
    },
});
</script>
